import { H2 } from 'components/Typography'
//import { MIST_CLOUD_URL } from 'app/consts'
import { WhiteBlock } from 'components/Layout'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { NetworkAlertsContainer, NetworkAlertsHeader } from './styles'

function NetworkAlerts() {
  return (
    <StyledFadeInWrapper>
      <NetworkAlertsContainer>
        <NetworkAlertsHeader>
          <H2>Alerts</H2>
        </NetworkAlertsHeader>

        <WhiteBlock></WhiteBlock>

        <NetworkAlertsHeader>
          <WhiteBlock></WhiteBlock>

          <WhiteBlock></WhiteBlock>
        </NetworkAlertsHeader>
      </NetworkAlertsContainer>
    </StyledFadeInWrapper>
  )
}

export default NetworkAlerts
